// extracted by mini-css-extract-plugin
export default {"headerContainer":"WelcomeTitle_headerContainer__0V07-","fadeInScale":"WelcomeTitle_fadeInScale__Yqkr4","logoImage":"WelcomeTitle_logoImage__VFJwe"};